var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavicons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navicons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.25 7.41602V14.0827C16.25 14.7457 15.9866 15.3816 15.5178 15.8504C15.0489 16.3193 14.413 16.5827 13.75 16.5827H6.25C5.58696 16.5827 4.95107 16.3193 4.48223 15.8504C4.01339 15.3816 3.75 14.7457 3.75 14.0827V7.41602",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.5 8.2509L16.25 7.41757L11.25 4.08424L10.4583 3.55924C10.3223 3.46963 10.1629 3.42188 10 3.42188C9.83708 3.42188 9.67773 3.46963 9.54167 3.55924L8.75 4.08424L3.75 7.41757L2.5 8.2509",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.33334 14.084H11.6667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavicons);
export default __webpack_public_path__ + "static/media/Navicons.4f0b884e0edc7b2895658b5651ea8700.svg";
export { ForwardRef as ReactComponent };